import apiClient from '../client';

export interface PublicationStatus {
  currentMonthPublished: boolean;
  targetDay: number;
  targetDayPassed: boolean;
  lastPublishedAt: string | null;
  lastSnapshotDate: string | null;
}

export interface PublishResult {
  id: number;
  snapshotDate: string;
  publishedAt: string;
  note: string | null;
}

export async function publishLatest(orgId: number, note?: string): Promise<PublishResult> {
  const r = await apiClient.post<PublishResult>('/admin/threats/publish', { orgId, note });
  return r.data;
}

export async function fetchPublicationStatus(orgId: number): Promise<PublicationStatus> {
  const r = await apiClient.get<PublicationStatus>(`/admin/threats/publication-status/${orgId}`);
  return r.data;
}
